require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-mainstream-child-seah-prevention.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-mainstream-child-seah-prevention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-mainstream-child-seah-prevention!./.cache/json/en-us-update-how-can-the-world-bank-mainstream-child-seah-prevention.json
// module id = 716
// module chunks = 231608221292675